'use strict';
(function () {
  angular.module('pentaApp').factory('callEmployee.resource', service);

  service.$inject = ['$resource'];
  function service($resource) {
    return $resource('/progressiveApp/api/callEmployee');
  }
})();
